import React from 'react'
import { Link } from 'react-router-dom'
import './PageNotFound.scss'

const PageNotFound = () => {
  return (
    <div className='page-not-found'>page not found :-(</div>
  )
}

export default PageNotFound